export type PrivilegedUser = {
  isSuperuser?: boolean | null;
  isDeveloper?: boolean | null;
};

// A developer holds the same rights as a superuser everywhere, except granting
// or revoking the developer role itself.
export const hasElevatedRights = (user?: PrivilegedUser | null) =>
  Boolean(user?.isSuperuser || user?.isDeveloper);
